var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-img',{class:{
    'w-136 h-60': _vm.hasCombo,
    'w-104 h-60': !_vm.hasCombo
  },attrs:{"src":_vm.vehicleImage,"contain":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }